import {SET_GMV_LIST} from "../../Actions/ActionConstants";

const GMVListReducer = (state = null, action) => {
    if (action.type === SET_GMV_LIST) {
        return action.data;
    } else {
        return state;
    }
};
export default GMVListReducer
